var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[(_vm.$store.state.company.under_maintenance)?[(_vm.$store.getters.isLoggedIn && _vm.bypass)?_c('auth'):_c('maintenance')]:[(!_vm.$store.getters.isLoggedIn)?_c('guest'):(_vm.$store.getters.isLoggedIn)?_c('auth'):_vm._e()]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }